import settingsModel, { Jurisdiction } from "slotworks/model/settings/settings-model";
import Point from "slotworks/utils/geom/point";
import canvasManager, { Orientation } from "slotworks/graphics/canvas/canvas-manager";
import deviceInfo from "slotworks/utils/device-info";
import BaseRegulation from "slotworks/integration/revolver/regulations/base-regulation";
import Timer from "slotworks/utils/timer";
import currency from "slotworks/i18n/currency";
import gameState from "slotworks/model/game-state";

export default class UKRegulation extends BaseRegulation{

    public static RESIZE_DOWN_ON_PORTRAIT: boolean = false;

    public canvas: HTMLElement;
    public landscapeCanvasDOMContainer: HTMLElement;
    public portraitCanvasDOMContainer: HTMLElement;
    public footerDOMContainer: HTMLElement;
    public bar: HTMLElement;
    public betmenuElements: HTMLElement[];
    public sessionTimer: HTMLElement;
    public netMetter: HTMLElement;

    protected startTime: number = 0;

    public constructor() {
        super();
    }

    public setup() {
        if(settingsModel.isJurisdiction(Jurisdiction.UK) && !settingsModel.hideUkJurisdictionBar) {
            this.canvas = document.getElementsByTagName('canvas')[0];
            this.landscapeCanvasDOMContainer = document.querySelector("#landscape #canvasDOMContainer") as HTMLElement;
            this.portraitCanvasDOMContainer = document.querySelector("#portrait #canvasDOMContainer") as HTMLElement || 
                                                document.querySelector("#portraitv2 #canvasDOMContainer") as HTMLElement;
            this.footerDOMContainer = document.querySelector("#portrait #footerDOMContainer") as HTMLElement ||
                                        document.querySelector("#portraitv2 #footerDOMContainer") as HTMLElement;
            this.bar = document.getElementById("ukTopBar") as HTMLElement;
            this.betmenuElements = [
            //    document.getElementById('autoplay'),
                document.getElementById('bet'),
                document.getElementById('settings'),
                document.getElementById('paytable').getElementsByTagName('span')[0],
                document.getElementById('rules'),
                document.getElementById('history'),
                document.getElementById('betmenu')
            ];
            this.sessionTimer = document.getElementById("uk_session") as HTMLElement; 
            this.netMetter = document.getElementById("uk_net") as HTMLElement;
            document.documentElement.classList.toggle("topBarOn", true);
        }
    }

    public gameReady() {
        if(this.bar) {
            const onOrientationChange = (orientation: number) => {
                if(orientation == Orientation.LANDSCAPE) {
                    this.onLandscape();
                }
                else {
                    this.onPortrait();
                }
            }
            canvasManager.onOrientationChange.add(onOrientationChange);
        }
    }

    public interactionStart() {
        if(this.startTime == 0) {
            this.sessionStart();
        }
        this.updateNetPosition(gameState.getNetPosition());
    }

    public updateNetPosition(netPosition: number) {
        if(this.netMetter) {
            this.netMetter.innerHTML = currency.format(netPosition);
        }
    }

    protected onLandscape() {
        const percent = deviceInfo.isDesktop ? 2 : 5
        let height = this.toNumber(this.canvas.style.height);
        const topBarHeight = Math.floor(height * percent / 100);
        let margin = this.toNumber(this.canvas.style.marginTop) + topBarHeight + "px";
        canvasManager.resizeElement(this.canvas,(height - topBarHeight)/height,new Point(0.5),true);
        canvasManager.resizeElement(this.landscapeCanvasDOMContainer,(height - topBarHeight)/height,new Point(0.5),true);
        this.landscapeCanvasDOMContainer.style.marginTop = margin;
        this.canvas.style.marginTop = margin;
        
        if(this.bar) {
            this.bar.style.marginTop = this.toNumber(this.canvas.style.marginTop) - topBarHeight + "px";
            this.bar.style.marginLeft = this.canvas.style.marginLeft
            this.bar.style.height = topBarHeight + "px";
            this.bar.style.width = this.canvas.style.width;
            this.bar.style.display = "flex";
            if(!deviceInfo.isDesktop) {
                this.bar.style.alignItems = "center";
                this.bar.style.fontSize = "2.5vh";
            }
        }
        if(!deviceInfo.isDesktop){
            //scale betmenu elements one by one since their position is fixed with 100% width and height set for each one independently
            this.betmenuElements.forEach(el => {
                ['width','height','margin'].forEach((attribute:any) => {
                    el.style[attribute] = this.canvas.style[attribute];
                })
            })
        }
    } 

    protected onPortrait() {
        const topBarHeight = 23; // Math.floor(height * percent / 100);
        let background = document.querySelector("#portrait #Background #default") as HTMLElement ||
                            document.querySelector("#portraitv2 #Background #default") as HTMLElement;;
        const headers = document.querySelectorAll("#portrait #Header>div,#portraitv2 #Header>div");
        if(headers) {
            headers.forEach(el => {
                (el as HTMLElement).style.marginTop = topBarHeight + "px";
            });
        }                     
        this.portraitCanvasDOMContainer.style.marginTop = topBarHeight + "px";
        
        if(UKRegulation.RESIZE_DOWN_ON_PORTRAIT) {
            canvasManager.resizeRendererToOrientation(false, Math.floor(1.5 * topBarHeight ));
            canvasManager.resizeElement(this.canvas, 1,new Point(0.5),true, true);
        }

        this.canvas.style.marginTop = topBarHeight + "px";
        background.style.marginTop = topBarHeight + "px";
        this.footerDOMContainer.style.marginTop = this.toNumber(this.footerDOMContainer.style.marginTop) - topBarHeight + 'px';
        if(this.bar) {
            this.bar.style.margin = '0';
            this.bar.style.height = topBarHeight + "px";
            this.bar.style.width = this.portraitCanvasDOMContainer.style.width;
            this.bar.style.display = "flex";
            this.bar.style.alignItems = "center";
            this.bar.style.fontSize = "small";
        }
        this.betmenuElements.forEach(el => {
            el.style.width = "100%";
            el.style.height = window.innerHeight - topBarHeight + 'px';
            el.style.margin = '0';
            el.style.marginTop = topBarHeight + "px";
        });
    }

    protected sessionStart() {
        this.startTime = Date.now();
        if(this.sessionTimer) {
            const format = (elapsed: number) => {
                var secs = elapsed % 60;
                elapsed = (elapsed - secs) / 60;
                var mins = elapsed % 60;
                var hrs = (elapsed - mins) / 60;
                return ((hrs < 10 ? "0" : "") + hrs + 
                    (mins < 10 ? ":0" : ":") + mins + 
                    (secs < 10 ? ":0" : ":") + secs);
            }
            const tick = () => {
                const diff =  Math.floor((Date.now() - this.startTime) / 1000);
                this.sessionTimer.innerHTML = format(diff);
            };
            tick();
            Timer.setInterval(tick, 500);
        }
    }

    protected toNumber = (str: string) => Number(str.split('px')[0]);

}




// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/regulations/uk/uk-regulation.ts